export default {"src":"/_next/static/media/CAT.34120b84.svg","height":18,"width":18};